import { APIModel } from "../api-model";

export class AcceptedTransplantDetails extends APIModel {
  transplant_date: string;
  transplant_or_region: string;
  organ_non_recovery: string;

   static fieldsToMap = {
    direct: [
      'transplant_date',
      'transplant_or_region',
      'organ_non_recovery'
    ],
    formatDate: [
      'transplant_date'
    ]
  }

  static buildFromAPI(record: any): AcceptedTransplantDetails {
    const row = new AcceptedTransplantDetails();
    record = record || {};

    this.mapFieldsDirectly<AcceptedTransplantDetails>(AcceptedTransplantDetails.fieldsToMap.direct, record, row);
    this.mapFormatDate<AcceptedTransplantDetails>(AcceptedTransplantDetails.fieldsToMap.formatDate, record, row);

    return row;
  }
}